import Enum from './Enum';

export default new Enum({
  INTE: 'Internet',
  REFE: 'Indicação',
  PAP: 'PAP',
  CALL: 'Ligação',
  PDV: 'PDV',
  LEAD: 'Leads',
  SMS: 'SMS',
  PIRA: 'Pirata',
  SIGN: 'Placa',
  ACTI: 'Ação',
});
